/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_Kb3Inputs */

const en_mk_cmp_clickup_kb3 = /** @type {(inputs: Mk_Cmp_Clickup_Kb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A formal approval with an action preview before anything goes out.`)
};

const id_mk_cmp_clickup_kb3 = /** @type {(inputs: Mk_Cmp_Clickup_Kb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval formal dengan pratinjau aksi sebelum apa pun keluar.`)
};

/**
* | output |
* | --- |
* | "A formal approval with an action preview before anything goes out." |
*
* @param {Mk_Cmp_Clickup_Kb3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_kb3 = /** @type {((inputs?: Mk_Cmp_Clickup_Kb3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_Kb3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_kb3(inputs)
	return en_mk_cmp_clickup_kb3(inputs)
});